import styled from 'styled-components';

export const ClientListWrapper = styled.div`
  .page-client-list__header {
    padding: 20px;
  }

  .AggridContainer {
    height: calc((var(--vh, 1vh) * 100) - 220px);
    padding: 0 20px 20px 20px;

    .client-list__toolbar {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 0 20px 12px;
      flex-wrap: wrap;
    }

    .client-list__toolbar-button {
      padding: 8px 14px;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      border: 1px solid #00a6ff;
      border-radius: 4px;
      background-color: #fff;
      color: #00a6ff;
      cursor: pointer;
      opacity: 1;
    }

    .client-list__toolbar-button--active {
      background-color: #00a6ff;
      color: #fff;
    }

    .client-list__toolbar-button--loading {
      cursor: wait;
      opacity: 0.6;
    }

    .client-list__bulk-select {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }

    .client-list__bulk-action-select {
      padding: 8px 32px 8px 12px;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      border: 1px solid #00a6ff;
      border-radius: 4px;
      background-color: #fff;
      color: #00a6ff;
      cursor: pointer;
      opacity: 1;
    }

    .client-list__bulk-action-select--disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    .client-list__selected-count {
      font-size: 12px;
      color: #666;
    }

    .client-status-block {
      text-align: center;
    }

    .client-list__row-count {
      height: 28px;
      padding: 0 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: #eaedf3;
    }

    /* ── Remove all borders on rows ── */
    .ag-row,
    .ag-row-selected,
    .ag-row:hover,
    .ag-row-selected:hover,
    .ag-row-focus,
    .ag-row-selected.ag-row-focus {
      border: none !important;
    }

    /* ── Selected row styles ── */
    .ag-row-selected {
      background-color: #e8f4fd !important;
    }

    .ag-row-selected:hover {
      background-color: #d6edfc !important;
    }

    /* Smooth transition on selection */
    .ag-row {
      transition: background-color 0.15s ease;
    }

    .ag-row:hover:not(.ag-row-selected) {
      background-color: #f5f7fa !important;
    }

    /* Nicer checkbox appearance */
    .ag-selection-checkbox .ag-icon-checkbox-checked {
      color: #00a6ff;
    }

    .ag-header-cell .ag-icon-checkbox-checked {
      color: #00a6ff;
    }

    /* Selected row text slightly bolder for emphasis */
    .ag-row-selected .ag-cell {
      font-weight: 500;
    }
  }
`;
